<template>
  <v-container>
    <div class="text-center">
      <v-btn
        color="red"
        class="mb-1"
        text
        @click="$store.state.experiments = $store.state.experimentsInherit"
        >Reset All</v-btn
      >
    </div>
    <v-row>
      <v-col v-for="experiment in computed" :key="experiment.id" cols="12">
        <v-card class="mx-auto" max-width="800">
          <v-card-title>
            <v-card-subtitle class="text-h5">
              {{ experiment.name }}
            </v-card-subtitle>
            <v-subheader v-if="experiment.compatible"> NATIVE </v-subheader>
            <v-subheader v-else> INHERIT </v-subheader>
          </v-card-title>
          <v-card-text>
            {{
              $store.state.experimentsInherit.meta[experiment.name].description
            }}<br />
            {{
              $date(
                $store.state.experimentsInherit.meta[experiment.name].createdAt
              ).format("DD/MM/YYYY")
            }}<br />
            <div
              v-if="
                $store.state.experimentsInherit.meta[experiment.name].refresh
              "
              style="color: #f44336"
            >
              Refresh required.
            </div>
            {{ typeof opt[experiment.name] }}
            <v-radio-group
              v-model="opt[experiment.name]"
              v-if="experiment.options"
            >
              <v-radio
                v-for="option in experiment.options"
                :key="option.value"
                :label="option.name"
                :value="
                  option.value === 'inherit'
                    ? $store.state.experimentsInherit[experiment.name]
                    : option.value
                "
              ></v-radio>
            </v-radio-group>
            <v-radio-group
              v-else-if="typeof opt[experiment.name] === 'boolean'"
              v-model="opt[experiment.name]"
            >
              <v-radio
                v-for="option in boolDefaults"
                :key="option.value"
                :label="option.name"
                :value="
                  option.value === 'inherit'
                    ? $store.state.experimentsInherit[experiment.name]
                    : option.value
                "
              ></v-radio>
            </v-radio-group>
            <v-text-field
              v-model="opt[experiment.name]"
              label="Value"
              type="number"
              v-else-if="typeof opt[experiment.name] === 'number'"
            ></v-text-field>
            <v-text-field
              v-model="opt[experiment.name]"
              label="Value"
              v-else
            ></v-text-field>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Experiments",
  data() {
    return {
      boolDefaults: [
        {
          name: "Inherit",
          value: "inherit"
        },
        {
          name: "On",
          value: true
        },
        {
          name: "Off",
          value: false
        }
      ],
      /* experiments: [
        {
          name: "USER_V2",
          createdAt: "2022-12-15",
          options: [
            {
              name: "Inherit",
              value: "inherit"
            },
            {
              name: "On",
              value: true
            },
            {
              name: "Off",
              value: false
            }
          ]
        },
        {
          name: "SFX_KFX",
          createdAt: "2022-12-15",
          affects: "SFX_KOLF",
          options: [
            {
              name: "Inherit",
              value: "inherit"
            },
            {
              name: "On",
              value: true
            },
            {
              name: "Off",
              value: false
            }
          ]
        },
        {
          name: "SFX_KOLF",
          createdAt: "2022-12-15",
          affects: "SFX_KFX",
          options: [
            {
              name: "Inherit",
              value: "inherit"
            },
            {
              name: "On",
              value: true
            },
            {
              name: "Off",
              value: false
            }
          ]
        }
      ]*/
      experiments: []
    }
  },
  computed: {
    computed() {
      return {
        // filter out experiment["meta"]
        ...Object.entries(this.$store.state.experimentsInherit)
          .filter(([k]) => k !== "meta")
          .map(([name, value]) => {
            return {
              name,
              compatible: false,
              value
            }
          }),
        ...this.experiments
          .filter(([k]) => k !== "meta")
          .map((experiment) => {
            return {
              ...experiment,
              compatible: true
            }
          })
      }
    },
    opt() {
      return this.$store.state.experiments
    }
  },
  watch: {
    opt: {
      handler() {
        // only save changes to localstorage, not ones that are still Inherit defaults
        const experiments = Object.entries(this.opt).reduce(
          (acc, [name, value]) => {
            try {
              const val = JSON.parse(value)
              if (val !== this.$store.state.experimentsInherit[name]) {
                acc[name] = val
              }
              return acc
            } catch (e) {
              console.log(e)
              if (value !== this.$store.state.experimentsInherit[name]) {
                acc[name] = value
              }
              return acc
            }
          },
          {}
        )
        localStorage.setItem("experiments", JSON.stringify(experiments))
      },
      deep: true
    }
  }
}
</script>

<style scoped></style>
